<template>
	<div class="position-relative app__form__field__checkbox">
		<label class="d-flex align-items-start app__form__checkbox" :for="inputId">
			<input
				:id="inputId"
				v-bind="$attrs"
				:checked="checked"
				:disabled="disabled"
				:value="value"
				type="checkbox"
				class="app__form__field__checkbox__native"
				@change="onChange"
			/>
			<span class="app__form__field__checkbox__box" aria-hidden="true">
				<app-icon v-if="checked" name="check" :size="14" :stroke-width="3" />
			</span>
			<span class="ms-3" v-if="hasSlot('default') || label">
				<span v-if="label" v-html="label"></span>
				<slot v-else />
			</span>
		</label>
		<input-error :errors="error" />
	</div>
</template>

<script setup>
import { computed, getCurrentInstance, useSlots } from 'vue';
import InputError from './Error.vue';

const props = defineProps({
	modelValue: {
		default: null,
	},
	value: {
		default: null,
	},
	binary: Boolean,
	trueValue: {
		default: true,
	},
	falseValue: {
		default: false,
	},
	disabled: Boolean,
	label: String,
	error: Object,
});

const emit = defineEmits(['update:modelValue', 'change', 'input']);
const slots = useSlots();
const inputId = `checkbox-${getCurrentInstance().uid}`;

const checked = computed(() => {
	if (props.binary) {
		return props.modelValue === props.trueValue;
	}

	return Array.isArray(props.modelValue) && props.modelValue.includes(props.value);
});

const onChange = (event) => {
	const isChecked = event.target.checked;
	let nextValue;

	if (props.binary) {
		nextValue = isChecked ? props.trueValue : props.falseValue;
	} else if (isChecked) {
		nextValue = [...(props.modelValue || []), props.value];
	} else {
		nextValue = (props.modelValue || []).filter((item) => item !== props.value);
	}

	emit('update:modelValue', nextValue);
	emit('change', event);
	emit('input', nextValue);
};

const hasSlot = (name) => !!slots[name];
</script>

<script>
export default {
	name: 'InputCheckbox',
	inheritAttrs: false,
};
</script>
